import OEToolbox from '../tools/oe-toolbox-core';

export class UpdateRetarder    {

    constructor(component) {
        this.component = component;
        this.inititated = false;
        this.initiate();
    }

    initiate()  {
        if(!this.component || this.component.retardingUpdate || this.inititated)   return;

        let component = this.component;

        this.shouldUpdateBackup = component.shouldComponentUpdate;
        this.shouldUpdate = {value: false};
        let shouldUpdate = this.shouldUpdate;

        if(this.shouldUpdateBackup)  {
            const shouldUpdateBackupBound = this.shouldUpdateBackup.bind(component);
            component.shouldComponentUpdate = function(nextProps, nextState) {
                shouldUpdate.value = shouldUpdate.value || shouldUpdateBackupBound(nextProps, nextState);
                return false;
            };
        } else if(component.isPureReactComponent)  {
            component.shouldComponentUpdate = function(nextProps, nextState) {
                shouldUpdate.value = shouldUpdate.value || !OEToolbox.shallowEqual(nextProps, component.props) || !OEToolbox.shallowEqual(nextState, component.state);
                return false;
            };
        } else {
            component.shouldComponentUpdate = function() {
                shouldUpdate.value = true;
                return false;
            };
        }

        this.inititated = true;

        component.retardingUpdate = true;
    }

    finish()    {
        if(!this.component || !this.component.retardingUpdate || !this.inititated) return;

        let component = this.component;

        component.retardingUpdate = false;

        component.shouldComponentUpdate = this.shouldUpdateBackup;
        if(this.shouldUpdate.value) component.forceUpdate();
        
        this.inititated = false;
    }
}

export default function retardUpdate(component, fn)    {
    if(component.retardingUpdate)   {
        fn();
        return;
    }
    
    const shouldUpdateBackup = component.shouldComponentUpdate;
    const shouldUpdate = {value: false};

    if(shouldUpdateBackup)  {
        const shouldUpdateBackupBound = shouldUpdateBackup.bind(component);
        component.shouldComponentUpdate = function(nextProps, nextState) {
            shouldUpdate.value = shouldUpdate.value || shouldUpdateBackupBound(nextProps, nextState);
            return false;
        };
    } else if(component.isPureReactComponent)  {
        component.shouldComponentUpdate = function(nextProps, nextState) {
            shouldUpdate.value = shouldUpdate.value || !OEToolbox.shallowEqual(nextProps, component.props) || !OEToolbox.shallowEqual(nextState, component.state);
            return false;
        };
    } else {
        component.shouldComponentUpdate = function() {
            shouldUpdate.value = true;
            return false;
        };
    }

    component.retardingUpdate = true;

    fn();

    component.retardingUpdate = false;
    
    component.shouldComponentUpdate = shouldUpdateBackup;
    if(shouldUpdate.value) component.forceUpdate();
} 